export enum VehicleNumberPlateType {
	Classic = 'classic',
	ClassicNoFlag = 'classic_no_flag',
	// ClassicSquare = 'classic_square',
	ClassicSquareNoFlag = 'classic_sq_no_flag',
	Custom = 'custom',
	CustomBlack = 'custom_black',
}

export type VehicleNumberPlateCategory = 'normal' | 'named';

export const vehicleNumberPlateTypesOrder = [
	VehicleNumberPlateType.Classic,
	VehicleNumberPlateType.ClassicNoFlag,
	// VehicleNumberPlateType.ClassicSquare,
	VehicleNumberPlateType.ClassicSquareNoFlag,
	VehicleNumberPlateType.Custom,
	VehicleNumberPlateType.CustomBlack,
] as const;

export const vehicleNumberPlateModIndexByType: Record<VehicleNumberPlateType, number> = {
	[VehicleNumberPlateType.Classic]: 0,
	[VehicleNumberPlateType.ClassicNoFlag]: 1,
	// [VehicleNumberPlateType.ClassicSquare]: 2,
	[VehicleNumberPlateType.ClassicSquareNoFlag]: 2,
	[VehicleNumberPlateType.Custom]: 3,
	[VehicleNumberPlateType.CustomBlack]: 4,
};

const vehicleNumberPlateCategories: Record<VehicleNumberPlateCategory, VehicleNumberPlateType[]> = {
	named: [VehicleNumberPlateType.Custom, VehicleNumberPlateType.CustomBlack],
	normal: [
		VehicleNumberPlateType.Classic,
		VehicleNumberPlateType.ClassicNoFlag,
		// VehicleNumberPlateType.ClassicSquare,
		VehicleNumberPlateType.ClassicSquareNoFlag,
	],
};

export function getVehicleNumberPlateCategory(type: VehicleNumberPlateType): VehicleNumberPlateCategory {
	if (type === VehicleNumberPlateType.Custom || type === VehicleNumberPlateType.CustomBlack) {
		return 'named';
	}

	return 'normal';
}

export function getVehicleNumberPlateTypesByCategory(category: VehicleNumberPlateCategory): VehicleNumberPlateType[] {
	return [...vehicleNumberPlateCategories[category]];
}

export function getNumberPlateTypeIndex(type: VehicleNumberPlateType): number | null {
	const index = vehicleNumberPlateTypesOrder.findIndex((e) => e === type);
	return index !== -1 ? index : null;
}

/**
 * Короткая подпись типа номера для UI
 */
export function getVehicleNumberPlateTypeCaption(type: VehicleNumberPlateType): string {
	switch (type) {
		case VehicleNumberPlateType.Classic:
			return 'Классический';
		case VehicleNumberPlateType.ClassicNoFlag:
			return 'Без флаговый';
		// case VehicleNumberPlateType.ClassicSquare:
		// 	return 'Квадратный с флагом';
		case VehicleNumberPlateType.ClassicSquareNoFlag:
			return 'Квадратный без флага';
		case VehicleNumberPlateType.Custom:
			return 'Именной белый';
		case VehicleNumberPlateType.CustomBlack:
			return 'Именной чёрный';
	}
}

export type VehicleNumberPlate = {
	/** Тип номера (фон, расположение текста и региона) */
	type: VehicleNumberPlateType;
	/** Текст номера */
	text: string;
	/** Номер региона (если есть) */
	region: string | null;
};

export interface INumberPlateRule {
	text: RegExp;
	region?: RegExp;
}

export const NUMBER_PLATE_RULES: Record<VehicleNumberPlateType, INumberPlateRule> = {
	[VehicleNumberPlateType.Classic]: {
		text: /^[ABEKMHOPCTYX]{1}(?!000)\d{3}[ABEKMHOPCTYX]{2}$/,
		region: /^(0[1-9]|[1-9]\d{1,2})$/,
	},
	[VehicleNumberPlateType.ClassicNoFlag]: {
		text: /^[ABEKMHOPCTYX]{1}(?!000)\d{3}[ABEKMHOPCTYX]{2}$/,
		region: /^(0[1-9]|[1-9]\d{1,2})$/,
	},
	// [VehicleNumberPlateType.ClassicSquare]: {
	// 	text: /^[ABEKMHOPCTYX]{1}(?!000)\d{3}[ABEKMHOPCTYX]{2}$/,
	// 	region: /^(0[1-9]|[1-9]\d{1,2})$/,
	// },
	[VehicleNumberPlateType.ClassicSquareNoFlag]: {
		text: /^[ABEKMHOPCTYX]{1}(?!000)\d{3}[ABEKMHOPCTYX]{2}$/,
		region: /^(0[1-9]|[1-9]\d{1,2})$/,
	},
	[VehicleNumberPlateType.Custom]: {
		text: /^[a-zA-Zа-яА-ЯёЁ0-9]{3,14}$/,
	},
	[VehicleNumberPlateType.CustomBlack]: {
		text: /^[a-zA-Zа-яА-ЯёЁ0-9]{3,14}$/,
	},
};
